module.exports = __webpack_public_path__ + "static/lizardfolk-f44a2640adbd7ac475dd7097d44bbac9.jpg";